import { CANDIDATE_MICROSERVICE } from "Constants";
import { ApiCall } from "components/common/services/ApiServices";
import { FILE_URL, GET_PARSING_DETAILS } from "routes/ApiEndpoints";
import { fillingContactForm } from "./SetCandidateData";
import CustomNotify from "components/common/atoms/CustomNotify";
// CR5: compare parsed CV data against the form instead of overwriting it.
import {
  buildCvSuggestions,
  buildAutoFillPayload,
  acceptNewItem,
  mirrorResidenceToDomicile,
  CvSuggestions,
} from "./cvSuggestions";

/**
 * Parse the uploaded CV and merge it NON-destructively:
 *  - empty fields / empty collections are auto-filled here (safe),
 *  - conflicts + brand-new info are returned to the caller so it can open the
 *    review popup (existing data is never overwritten automatically).
 * Returns null when there is nothing parsed.
 */
export const SetCvParsingData = async (
  data: any,
  dispatch: any,
  state: any
): Promise<CvSuggestions | null> => {
  const cvPath = data[2] ?? "";
  if (cvPath === "") return null;

  const cvUrl = `${FILE_URL}/${cvPath}`;
  const response = await ApiCall.service(
    `${GET_PARSING_DETAILS}`,
    "POST",
    { cvUrl },
    true,
    CANDIDATE_MICROSERVICE
  );

  if (response?.status !== 200) {
    CustomNotify({ type: "error", message: "Some error occured" });
    return null;
  }

  // 1) Classify parsed data vs the current form.
  const suggestions = buildCvSuggestions(response?.data, state);

  // 2) Apply ONLY the safe auto-fills (empty fields / empty collections).
  //    Reuses fillingContactForm so date/ssn formatting stays consistent.
  const { payload, competences } = buildAutoFillPayload(suggestions);
  // CR-576: mirror residence → domicile when "Same as residence address" is on
  // (the form does this on manual entry; programmatic auto-fill bypasses it).
  if (state?.general?.domCheckbox && payload.generalDetails) {
    mirrorResidenceToDomicile(payload.generalDetails);
  }
  fillingContactForm(payload, dispatch);
  if (competences) {
    dispatch({ type: "UPDATE_COMPETENCES", payload: competences });
    dispatch({ type: "UPDATE_CHILD_COMPETENCES_DATA" });
  }

  // 3) Auto-add every brand-new entry (studies / experience / languages / IT /
  //    soft skills) directly — no popup. Uses live-state reducer actions so many
  //    entries apply without colliding; dedupe means re-parsing never duplicates.
  suggestions.newItems.forEach((item) => acceptNewItem(item, state, dispatch));

  // 4) Only conflicts need the recruiter's decision, so that's all the popup gets.
  return { ...suggestions, newItems: [] };
};
